import {createContext, useReducer} from "react";

export const SubCasteContext = createContext();

export const subcasteReducer = (state,action) => {
    switch(action.type){
        case 'SET_SUBCASTES':
            return {
                subcastes: action.payload
            }
        
        case 'CREATE_SUBCASTE':
            return {
                subcastes: [action.payload.subcaste,...state.subcastes]
            }

        case 'DELETE_SUBCASTE':
            return {
                subcastes: state.subcastes.filter((subcaste) => subcaste._id !== action.payload._id)
            }

        default:
            return state
    }
}

export const SubCasteContextProvidor = ({children}) =>{
    const [state,dispatch] = useReducer(subcasteReducer,{
       subcastes: null,
    });

    return (
        <SubCasteContext.Provider value={{...state,dispatch}}>
            {children}
        </SubCasteContext.Provider>
    )
}